import React from 'react'

import { Button, Modal, Pagination, Stack } from '@shopify/polaris'

import comgate1 from '../assets/comgate01.jpg'
import comgate2 from '../assets/comgate02.jpg'
import comgate3 from '../assets/comgate03.jpg'
import comgate4 from '../assets/comgate04.jpg'
import { getTranslation } from '../util/getTranslation'

const stepImages = [comgate1, comgate2, comgate3, comgate4]

export function ComGateCredentialsGuide() {
  const [open, setOpen] = React.useState(false)
  const [activeStep, setActiveStep] = React.useState(0)

  const toggleModal = React.useCallback(() => setOpen((open) => !open), [])

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const title = getTranslation('comgate.credentials_guide_title')

  const activator = (
    <Button plain onClick={toggleModal}>
      {title}
    </Button>
  )

  return (
    <Modal
      activator={activator}
      open={open}
      onClose={toggleModal}
      title={getStepExplanation(activeStep)}
      large
      primaryAction={{
        content: getTranslation('common.close'),
        onAction: toggleModal,
      }}
      footer={
        <Stack distribution="trailing">
          <Pagination
            hasNext={activeStep < 3}
            hasPrevious={activeStep > 0}
            onNext={handleNext}
            onPrevious={handleBack}
            label={getTranslation('comgate.guide_navigation')}
          />
        </Stack>
      }
    >
      <Modal.Section>
        <img src={stepImages[activeStep]} alt="" />
      </Modal.Section>
    </Modal>
  )
}

function getStepExplanation(stepIdx: number) {
  switch (stepIdx) {
    case 0:
      return getTranslation('comgate.step_0')
    case 1:
      return getTranslation('comgate.step_1')
    case 2:
      return getTranslation('comgate.step_2')
    case 3:
      return getTranslation('comgate.step_3')
    default:
      return null
  }
}

export default ComGateCredentialsGuide
